import { useState, useEffect } from "react"
import Backdrop from "@mui/material/Backdrop"
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import CircularProgress from "@mui/material/CircularProgress"
import { keyframes } from "@mui/system"
import DescriptionIcon from "@mui/icons-material/Description"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"

interface DocumentLoadingScreenProps {
  open: boolean
  message?: string
  subMessage?: string
}

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`

export default function LoadPreventa({
  open = false,
  message = "Revisando documentos",
  subMessage = "Por favor espera mientras procesamos tu información",
}: DocumentLoadingScreenProps) {
  const [currentDoc, setCurrentDoc] = useState(0)


  useEffect(() => {
    if (open) {
      setCurrentDoc(0)
    }
  }, [open])

  useEffect(() => {
    if (!open) return
    const docInterval = setInterval(() => {
      setCurrentDoc((prev) => (prev + 1) % 3)
    }, 1500)

    return () => {
      clearInterval(docInterval)
    }
  }, [open])

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
      }}
    >
      <Paper
        elevation={24}
        sx={{
          width: "100%",
          maxWidth: 500,
          p: 4,
          mx: 2,
          textAlign: "center",
          borderRadius: 2,
        }}
      >
        {/* Animated document icons */}
        <Box
          sx={{
            height: 128,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            mb: 1,
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                position: "relative",
                animation: `${float} 2s ease-in-out ${index * 0.2}s infinite`,
              }}
            >
              <DescriptionIcon
                sx={{
                  fontSize: 48,
                  color: index === 1 ? "primary.main" : "action.disabled",
                }}
              />
              {index === 1 && currentDoc >= 2 && (
                <CheckCircleIcon
                  sx={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    fontSize: 20,
                    color: "success.main",
                  }}
                />
              )}
            </Box>
          ))}
        </Box>

        {/* Loading spinner */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <CircularProgress size={32} />
        </Box>

        {/* Main message */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight={600}>
            {message}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {subMessage}
          </Typography>
        </Box>



      </Paper>
    </Backdrop>
  )
}
